export function appendTranscript(message: string, transcript: string): string {
  const trimmedTranscript = transcript.trim()
  return message.trim() ? `${message} ${trimmedTranscript}` : trimmedTranscript
}
